import React from 'react';
import Helmet from 'react-helmet';
import Moment from 'moment';
import _ from 'lodash';
import {
  SafetyDiaryForm,
  SafetyDiaryFormData,
} from '../components/forms/SafetyDiaryForm';
import Confirmation from '../components/modals/common/Confirmation';
import Information from '../components/modals/common/Information';
import { FieldService } from '../services/Fields';
import ExternalServiceCooperationStatusApi from '../services/ExternalServiceCooperationStatusApi';
import { SafetyDiaryService } from '../services/SafetyDiaries';
import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';
import {
  FLAG_STAUS,
  HEADER_CONSTANTS,
  DIRECT_STATUS_CODE,
} from '../utilities/constants';
import { messageUtility } from '../utilities/messageUtility';
import SafetyDiariesConstants from '../utilities/safetyDiariesConstants';
import _slideLoader from '../utilities/slideLoader';
import { ConferencePageHeader } from '../components/PageHeader';
import { localizeMessage } from '../utilities/validateMessage';
import safetyDiariesConstants from '../utilities/safetyDiariesConstants';

// ダイアログ名
const DIALOG_NAME = {
  notNotifiedUsers: 'notNotifiedUsers', // 通知対象外ユーザー
};

/**
 * @description 巡回記録一括登録
 */
export class SafetyDiariesBulkRegister extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fieldId: SessionStorageService.getFieldId(), // 現場ID
      userId: LocalStorageService.getUserId(), // ユーザーID
      uploadFiles: [], // 選択画像
      formDataList: [], // 設定フォームデータ
      displayFlg: {
        field_item_list1_display_flag: '', // 作業場所フラグ1
        field_item_list2_display_flag: '', // 作業場所フラグ2
        field_item_list3_display_flag: '', // 作業場所フラグ3
        field_item_list4_display_flag: '', // 作業場所フラグ4
      },
      selectedId: 0, // 選択画像ID
      visibleDialogFlag: false, // ダイアログフラグ
      visibleDialogName: null, // ダイアログ名
      notNotifiedUsers: [], // 通知対象外ユーザー
      validateMessages: {}, // バリデーションメッセージ
      loaded: false,
      hasError: false,
      externalServiceCooperationStatus: {
        line_works: {
          available: false,
        },
        direct: {
          available: false,
          reason_code: null,
        },
      },
      callApiDirectTalkRoomStatus: false,
      directTalkRooms: [],
    };

    this.updatingFlag = false; // 多重更新防止Flag

    this.handleBulkUpload = this.handleBulkUpload.bind(this);
    this.inputValidate = this.inputValidate.bind(this); // バリデーションチェック
    this.onClose = this.props.view.state.onClose;
    this.onCloseSlide = this.props.view.state.onCloseSlide;
  }

  handleFormUpdate = (formData, id) => {
    const newItemArr = _.cloneDeep(this.state.formDataList);
    const index = _.findIndex(
      newItemArr,
      formDataObject => formDataObject.bulkId === id
    );
    // データが見つからなかったとき
    if (index < 0) {
      return;
    }
    newItemArr[index] = {
      bulkId: id,
      formData,
      uploadImages: newItemArr[index].uploadImages,
    };
    this.setState({ formDataList: newItemArr });
  };

  handleDeleteForm = bulkId => {
    const formDataList = _.cloneDeep(this.state.formDataList);
    const validateMessages = _.cloneDeep(this.state.validateMessages);
    delete validateMessages[bulkId];
    _.remove(formDataList, formDataObj => formDataObj.bulkId === bulkId);
    this.handleVisibleDialog(false);
    this.setState({ formDataList, validateMessages });
  };

  componentDidMount = () => {
    this.getFieldItemFlag();
    this.getExternalServiceCooperationStatus();
  };

  componentDidUpdate(prevProps, prevState) {
    // this.state.formDataListが空なら前画面に遷移
    if (this.state.formDataList.length === 0) {
      _slideLoader.close(this.props.vw);
    }
    if (
      !_.isEqual(prevState.validateMessages, this.state.validateMessages) ||
      !_.isEqual(prevState.formDataList, this.state.formDataList)
    ) {
      const { reportType } = SafetyDiariesConstants;
      const { validateMessages, formDataList } = this.state;
      const positiveId = FLAG_STAUS.positive.id;
      let hideErrorMessages = true;
      _.each(formDataList, item => {
        if (_.isUndefined(validateMessages[item.bulkId])) {
          return;
        }
        const {
          notifications_manager_flag,
          notifications_company_flag,
          notifications_group_flag,
          type,
          send_external_service_cooperation,
        } = item.formData;
        const isShowSendExternalServiceCooperation =
          send_external_service_cooperation &&
          [
            reportType.pointOut.id,
            reportType.contact.id,
            reportType.wellKnown.id,
          ].includes(type);
        const hasNoErrorSub =
          (type !== reportType.pointOut.id &&
            type !== reportType.wellKnown.id) ||
          (type === reportType.pointOut.id &&
            !(
              (_.has(validateMessages[item.bulkId], 'notification_manager') &&
                notifications_manager_flag === positiveId) ||
              (_.has(
                validateMessages[item.bulkId],
                'notification_field_tree'
              ) &&
                notifications_company_flag === positiveId) ||
              (_.has(validateMessages[item.bulkId], 'notification_group') &&
                notifications_group_flag === positiveId)
            )) ||
          (type === reportType.wellKnown.id &&
            !_.has(validateMessages[item.bulkId], 'end_date'));
        hideErrorMessages = hideErrorMessages && hasNoErrorSub;
        if (
          isShowSendExternalServiceCooperation &&
          (_.has(validateMessages[item.bulkId], 'lw_talkroom_ids') ||
            _.has(validateMessages[item.bulkId], 'direct_talkroom_ids'))
        ) {
          hideErrorMessages = false;
        }
      });
      this.setState({
        hasError: !hideErrorMessages,
      });
    }
  }

  UNSAFE_componentWillMount() {
    const files = this.props.view.state.uploadFiles
      ? this.props.view.state.uploadFiles
      : [];
    const formDataList = _.map(files, (file, i) => {
      return {
        bulkId: i,
        formData: { ...SafetyDiaryFormData, image1: file },
        uploadImages: [{ id: 1, file, url: '' }],
      };
    });
    this.setState({ formDataList });
  }

  /**
   * @description 作業場所フラグ情報取得
   */
  getFieldItemFlag() {
    FieldService.fieldItem(this.state.fieldId).then(response => {
      if (response.result === true) {
        const displayFlg = _.cloneDeep(this.state.displayFlg);
        const field_item = response.data.entities.field_item;
        _.each(displayFlg, (value, key) => {
          displayFlg[key] = field_item[key];
        });
        this.setState({ displayFlg, loaded: true });
      }
    });
  }

  // 巡回記録 一括登録 処理
  handleBulkUpload = () => {
    // 多重更新防止
    if (this.updatingFlag === true) {
      return;
    }
    this.updatingFlag = true;

    const formDataList = this.state.formDataList;
    const isSuccess = this.submitValidate(formDataList);
    if (!isSuccess) {
      this.updatingFlag = false;
      return;
    }

    const postDataList = formDataList.map(element => {
      if (
        Number(element.formData.send_external_service_cooperation) ===
        FLAG_STAUS.negative.id
      ) {
        element.formData.lw_talkroom_ids = [];
        element.formData.direct_talkroom_ids = [];
      }
      return {
        ...element.formData,
        create_user_id: this.state.userId,
        content_update_user_id: this.state.userId,
        field_id: this.state.fieldId,
      };
    });
    const postData = {
      data: postDataList,
    };

    SafetyDiaryService.register(this.state.fieldId, postData).then(response => {
      if (response.result === true) {
        const notNotifiedUsers = response.data.entities.not_notified_users;
        if (_.size(notNotifiedUsers) > 0) {
          this.setState({
            notNotifiedUsers,
            visibleDialogName: DIALOG_NAME.notNotifiedUsers,
          });
        } else {
          this.onCloseSlide();
        }
      }
    }).finally(() => {
      this.updatingFlag = false;
    });
  };

  handleOpenModal = id => {
    this.handleVisibleDialog(true);
    this.setState({ selectedId: id });
  };

  /**
   * @description ダイアログ開閉設定
   * @param {string} visibleDialogFlag ダイアログフラグ
   */
  handleVisibleDialog(visibleDialogFlag) {
    this.setState({ visibleDialogFlag });
  }

  /**
   * @description バリデーションチェック(入力時)
   * @param {object} formValues 全入力値
   * @param {int} bulkId 一括登録ID
   * @param {string} name
   */
  inputValidate(formValues, bulkId, name) {
    const { reportType } = SafetyDiariesConstants;
    let validateMessages = _.cloneDeep(this.state.validateMessages);
    const {
      type,
      entries_date,
      end_date,
      send_external_service_cooperation,
    } = formValues;
    const isShowSendExternalServiceCooperation =
      send_external_service_cooperation &&
      [
        reportType.pointOut.id,
        reportType.contact.id,
        reportType.wellKnown.id,
      ].includes(type);

    if (_.isUndefined(validateMessages[bulkId])) {
      validateMessages[bulkId] = {};
    }
    if (
      Number(type) === reportType.wellKnown.id &&
      !Moment(entries_date, 'YYYY/MM/DD').isSameOrBefore(end_date, 'YYYY/MM/DD')
    ) {
      validateMessages[bulkId].end_date = messageUtility.getMessage(
        'E-001-311'
      );
    } else {
      delete validateMessages[bulkId].end_date;
    }

    const isPointOut = Number(type) === reportType.pointOut.id;
    if (isPointOut && name) {
      if (_.isEmpty(formValues[name])) {
        validateMessages[bulkId][name] = localizeMessage.required;
      } else {
        delete validateMessages[bulkId][name];
      }
    }
    const { keyLwId } = SafetyDiariesConstants;
    if (isShowSendExternalServiceCooperation && _.includes(keyLwId, name)) {
      if (_.isEmpty(formValues[name])) {
        validateMessages[bulkId][name] = localizeMessage.required;
      }
      if (
        !_.isEmpty(formValues.lw_talkroom_ids) ||
        !_.isEmpty(formValues.direct_talkroom_ids)
      ) {
        validateMessages[bulkId] = _.omit(validateMessages[bulkId], keyLwId);
      }
    }
    this.setState({ validateMessages });
  }

  /**
   *
   * @memberof SafetyDiariesBulkRegister
   */
  validateNotificationTargetOnSubmit = (
    formData,
    validateMessages,
    isPointOut,
    isShowSendNotificationLw
  ) => {
    let newValidateMessage = _.cloneDeep(validateMessages);
    newValidateMessage = this.validateAllTalkRoom(
      newValidateMessage,
      isShowSendNotificationLw,
      formData
    );
    if (!isPointOut) {
      delete newValidateMessage.notification_manager;
      delete newValidateMessage.notification_field_tree;
      delete newValidateMessage.notification_group;
      return newValidateMessage;
    }
    if (formData.notifications_manager_flag !== FLAG_STAUS.positive.id) {
      delete newValidateMessage.notification_manager;
    } else {
      if (_.isEmpty(formData.notification_manager)) {
        newValidateMessage.notification_manager = localizeMessage.required;
      }
    }
    if (formData.notifications_company_flag !== FLAG_STAUS.positive.id) {
      delete newValidateMessage.notification_field_tree;
    } else {
      if (_.isEmpty(formData.notification_field_tree)) {
        newValidateMessage.notification_field_tree = localizeMessage.required;
      }
    }
    if (formData.notifications_group_flag !== FLAG_STAUS.positive.id) {
      delete newValidateMessage.notification_group;
    } else {
      if (_.isEmpty(formData.notification_group)) {
        newValidateMessage.notification_group = localizeMessage.required;
      }
    }
    return newValidateMessage;
  };

  /**
   * @description バリデーションチェック(登録時)
   * @param {object} formValues 全入力値
   */
  submitValidate(formValues) {
    const { reportType } = SafetyDiariesConstants;
    const validateMessages = _.cloneDeep(this.state.validateMessages);

    _.each(formValues, item => {
      if (_.isUndefined(validateMessages[item.bulkId])) {
        validateMessages[item.bulkId] = {};
      }
      if (
        Number(item.formData.type) === reportType.wellKnown.id &&
        !Moment(item.formData.entries_date, 'YYYY/MM/DD').isSameOrBefore(
          item.formData.end_date,
          'YYYY/MM/DD'
        )
      ) {
        validateMessages[item.bulkId].end_date = messageUtility.getMessage(
          'E-001-311'
        );
      } else {
        delete validateMessages[item.bulkId].end_date;
      }
      const isPointOut = Number(item.formData.type) === reportType.pointOut.id;
      const isShowSendExternalServiceCooperation =
        item.formData.send_external_service_cooperation &&
        [
          reportType.pointOut.id,
          reportType.contact.id,
          reportType.wellKnown.id,
        ].includes(item.formData.type);
      validateMessages[item.bulkId] = this.validateNotificationTargetOnSubmit(
        item.formData,
        validateMessages[item.bulkId],
        isPointOut,
        isShowSendExternalServiceCooperation
      );
      if (_.isEmpty(validateMessages[item.bulkId])) {
        delete validateMessages[item.bulkId];
      }
    });

    this.setState({ validateMessages });

    return _.size(validateMessages) === 0;
  }

  getExternalServiceCooperationStatus = async () => {
    const response = await ExternalServiceCooperationStatusApi.list.get({
      field_id: this.state.fieldId,
    });
    if (response.result) {
      const externalServiceCooperationStatus = _.get(response, 'data.entities');
      this.setState(
        {
          externalServiceCooperationStatus,
        },
        () => {
          if (_.get(externalServiceCooperationStatus, 'direct.available')) {
            this.checkDirectTalkRoom();
          }
        }
      );
    }
  };

  checkDirectTalkRoom = async () => {
    let status = false;
    let directTalkRooms = [];
    const response = await FieldService.listDirectRooms({
      field_id: this.state.fieldId,
    });
    if (response.result) {
      status = true;
      directTalkRooms = _.get(response, 'data.entities.direct_talkrooms') || [];
    }
    this.setState({
      callApiDirectTalkRoomStatus: status,
      directTalkRooms,
    });
  };

  validateAllTalkRoom = (
    validateMessages,
    isShowSendNotificationLw,
    formData
  ) => {
    const { keyLwId } = safetyDiariesConstants;
    if (!isShowSendNotificationLw) {
      return _.omit(validateMessages, keyLwId);
    }
    const { lw_talkroom_ids, direct_talkroom_ids } = formData;
    const { line_works, direct } = this.state.externalServiceCooperationStatus;
    const isRequiredLw = line_works.available;
    const isRequiredDirect =
      direct.available || direct.reason_code === DIRECT_STATUS_CODE.UNAVAILABLE;
    if (isRequiredLw && isRequiredDirect) {
      if (!_.isEmpty(lw_talkroom_ids) || !_.isEmpty(direct_talkroom_ids)) {
        return _.omit(validateMessages, keyLwId);
      }
      _.forEach(keyLwId, key => {
        validateMessages[key] = localizeMessage.required;
      });
      return validateMessages;
    }
    if (isRequiredLw) {
      if (_.isEmpty(lw_talkroom_ids)) {
        validateMessages.lw_talkroom_ids = localizeMessage.required;
      } else {
        validateMessages = _.omit(validateMessages, 'lw_talkroom_ids');
      }
      return validateMessages;
    }
    if (isRequiredDirect) {
      if (_.isEmpty(direct_talkroom_ids)) {
        validateMessages.direct_talkroom_ids = localizeMessage.required;
      } else {
        validateMessages = _.omit(validateMessages, 'direct_talkroom_ids');
      }
      return validateMessages;
    }
    return validateMessages;
  };

  render() {
    return (
      <div className='slide-view show'>
        <Helmet>
          <title>{HEADER_CONSTANTS.conference} - 巡回記録一括登録</title>
        </Helmet>
        <div className='slide-view__view'>
          <ConferencePageHeader
            dataTestId={`safety-diaries-bulk-register`}
            title={<div className='slide-view__title'>巡回記録一括登録</div>}
            leftComponent={
              <button
                className={
                  this.state.hasError ? 'btn--disabled' : 'btn--effective'
                }
                onClick={this.handleBulkUpload}
              >
                登録
              </button>
            }
            rightComponent={
              <div className='slide-view__header-end-item'>
                <div className='form-list__header-alert show'>
                  {!this.state.hasError ? '' : '入力エラーがあります。'}
                </div>
              </div>
            }
            onClose={() => this.onClose()}
          />

          <div className='slide-view__body SafetyDiaries'>
            {_.map(this.state.formDataList, list => {
              return (
                <SafetyDiaryForm
                  key={list.bulkId}
                  value={this.state.displayFlg}
                  isBulk={true}
                  bulkId={list.bulkId}
                  uploadImages={list.uploadImages}
                  formData={list.formData}
                  onUpdate={formData => {
                    this.handleFormUpdate(formData, list.bulkId);
                  }}
                  onDeleteForm={() => this.handleOpenModal(list.bulkId)}
                  onValidate={this.inputValidate}
                  setValidateMessages={newErrors =>
                    this.setState(prevState => ({
                      validateMessages: {
                        ...prevState.validateMessages,
                        [list.bulkId]: newErrors,
                      },
                    }))
                  }
                  errors={_.defaultTo(
                    this.state.validateMessages[list.bulkId],
                    {}
                  )}
                  loaded={this.state.loaded}
                  isSpace={true}
                  externalServiceCooperationStatus={
                    this.state.externalServiceCooperationStatus
                  }
                  callApiDirectTalkRoomStatus={
                    this.state.callApiDirectTalkRoomStatus
                  }
                  directTalkRooms={this.state.directTalkRooms}
                />
              );
            })}
          </div>
        </div>
        <Confirmation
          visible={this.state.visibleDialogFlag}
          title='画像・入力内容の削除'
          message={messageUtility.getMessage('E-001-312')}
          confirmButtonText={messageUtility.getMessage('I-000-018')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          isNegative={true}
          onConfirm={() => this.handleDeleteForm(this.state.selectedId)}
          onCancel={() => this.handleVisibleDialog(false)}
        />
        <Information
          rootClassName='SafetyDiaries__not-notified-user-modal'
          title='通知対象の確認'
          visible={
            this.state.visibleDialogName === DIALOG_NAME.notNotifiedUsers
          }
          message={
            <React.Fragment>
              {messageUtility.getMessage('I-001-421')}
              <br />
              <br />
              <div>
                <table>
                  {_.map(this.state.notNotifiedUsers, user => {
                    return (
                      <tr key={_.random(1, true)}>
                        <td>{user.company_name}</td>
                        <td>：</td>
                        <td>{user.user_name}</td>
                      </tr>
                    );
                  })}
                </table>
              </div>
            </React.Fragment>
          }
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={() => this.onCloseSlide()}
          multilineText={true}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/SafetyDiariesBulkRegister.jsx